import { IReduxAction, IState } from "../model";
import { 
  SET_COURSE_INSTANCE, 
  UPDATE_COURSE_INSTANCE_SUCCESS, 
  CREATE_COURSE_INSTANCE_ERROR, 
  UPDATE_COURSE_INSTANCE_ERROR, 
  CLEAR_COURSE_INSTANCE_ERRORS,
  CLEAR_COURSE_INSTANCE_STATE, 
  GET_EMAIL_TEMPLATES_SUCCESS,
  GET_EMAIL_TEMPLATES_FAILURE
} from "./start-course-instance.action";

const initialState = {
    courseInstance: null,
    updateCourseIns: null,
    createCourseInstanceError: null,
    updateCourseInstanceError: null,
    emailTemplates: {
      loading: false,
      templates: [],
      error: null,
    },
};

export const courseInstanceReducer = (
  state: typeof initialState = initialState,
  action: IReduxAction
): any => {
  switch (action.type) {
    case SET_COURSE_INSTANCE:
      return {
        ...state,
        courseInstance: action.payload,
        createCourseInstanceError: null,
      };
    case UPDATE_COURSE_INSTANCE_SUCCESS:
       return {
        ...state,
        updateCourseIns: action.payload,
        updateCourseInstanceError: null,
       };
    case CREATE_COURSE_INSTANCE_ERROR:
      return {
        ...state,
        createCourseInstanceError: action.payload,
        courseInstance: null,
      };
    case UPDATE_COURSE_INSTANCE_ERROR:
      return {
        ...state,
        updateCourseInstanceError: action.payload,
        updateCourseIns: null,
      };
    case CLEAR_COURSE_INSTANCE_ERRORS:
      return {
        ...state,
        createCourseInstanceError: null,
        updateCourseInstanceError: null,
      };
    case CLEAR_COURSE_INSTANCE_STATE:
      return {
        ...state,
        courseInstance: null,
        updateCourseIns: null,
        createCourseInstanceError: null,
        updateCourseInstanceError: null,
      };
    case GET_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        emailTemplates: {
          loading: false,
          templates: action.response,
          error: null,
        },
      };
    case GET_EMAIL_TEMPLATES_FAILURE:
      return {
        ...state,
        emailTemplates: {
          loading: false,
          templates: [],
          error: action.response,
        },
      };
    default:
      return state;
  }
}
